import { render, staticRenderFns } from "./PageBuild.vue?vue&type=template&id=56d15193&scoped=true&"
import script from "./PageBuild.vue?vue&type=script&lang=js&"
export * from "./PageBuild.vue?vue&type=script&lang=js&"
import style0 from "./PageBuild.vue?vue&type=style&index=0&id=56d15193&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d15193",
  null
  
)

export default component.exports